var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{style:({ width: '200px', 'height': '200px' })},[_c('vue-qr',{attrs:{"text":_vm.qrUrl,"qid":"testid"}}),_c('a',{attrs:{"href":_vm.qrUrl,"target":"_blank"}},[_vm._v("查看详情")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }